interface AuthData {
    userId: string;
    fullName: string;
    permissions: string;
    access: string[];
    theme: string;
    otp_enabled: boolean;
}

export class SessionUser {
    userId: string;
    fullName: string;
    permissions: string;
    access: string[];
    theme: string;
    otp_enabled: boolean;
    
    constructor(data: AuthData) {
        this.userId = data.userId;
        this.fullName = data.fullName;
        this.permissions = data.permissions;
        this.access = data.access;
        this.theme = data.theme;
        this.otp_enabled = data.otp_enabled;
    }

    canAccessPage(page: string) {
        return true;
        const access = (this.access || []);

        return access.includes("all") || access.includes(page);
    }
}
